import {Injectable} from "@angular/core";
import { DataProviderFactory, DataRequest } from "app/provider/data2.provider";
import { mergeFilterParams } from "../lib/lib";
import { FilterParams } from "../models/filter_form.model";
import { BaseService } from "../views/base.service";
import { HttpClient } from "@angular/common/http";


@Injectable()
export class BillingService2 extends BaseService {
	public siteBilling: DataRequest;
	public balance: DataRequest;
	public conversion: DataRequest;
	public conversionSource: DataRequest;
	
	// Загадочный отчёт. Есть в бою, работает, лишь базы yandex_metrika нет.
	// Пока не смогли вспомнить что это, и почему в таком виде есть в бою
	public conversionRate: DataRequest;
	public disableRecurrent: DataRequest;
	public error: DataRequest;
	public expiredPaid: DataRequest;
	public promocode: DataRequest;
	public geo: DataRequest;
	public manualPaid: DataRequest;
	public ones: DataRequest;
	public return: DataRequest;
	public money: DataRequest;
	public paymentStructure: DataRequest;
	public domainBilling: DataRequest;
	public templateBilling: DataRequest;
	public promopultBilling: DataRequest;
	public tail: DataRequest;
	public uber: DataRequest;
	public withdrawalsRecurrent: DataRequest;
	public beforePaid: DataRequest;
	public operationData: DataRequest;
	public zeroDay: DataRequest;

	constructor(
		public dpf: DataProviderFactory,
		public http: HttpClient,
	) {
		super(http);
		
		this.balance = this.dpf.getNew('balance');
		this.siteBilling = this.dpf.getNew('billing');
		this.conversion = this.dpf.getNew('conversion');
		this.conversionSource = this.dpf.getNew('billing/conversion_source');
		this.conversionRate = this.dpf.getNew('conversion_rate');
		this.disableRecurrent = this.dpf.getNew('billing/disable_recurrent');
		this.error = this.dpf.getNew('billing/errors');
		this.expiredPaid = this.dpf.getNew('expired_paid');
		this.promocode = this.dpf.getNew('promocode');
		this.geo = this.dpf.getNew('geo');
		this.manualPaid = this.dpf.getNew('manual_paid');
		this.ones = this.dpf.getNew('billing/ones');
		this.return = this.dpf.getNew('billing/return');
		this.money = this.dpf.getNew('money');
		this.paymentStructure = this.dpf.getNew('payment_structure');
		this.domainBilling = this.dpf.getNew('domain_billing');
		this.templateBilling = this.dpf.getNew('template_billing');
		this.promopultBilling = this.dpf.getNew('billing/promopult');
		this.tail = this.dpf.getNew('billing/tail');
		this.uber = this.dpf.getNew('uber');
		this.withdrawalsRecurrent = this.dpf.getNew('billing/withdrawals_recurrent');
		this.beforePaid = this.dpf.getNew('before_paid');
		this.operationData = this.dpf.getNew('operation_data');
		this.zeroDay = this.dpf.getNew('billing/zero_day');
	}
}
